// extracted by mini-css-extract-plugin
export default {"languageDropdown":"E1Sq7ta2zvUwgNImjh_K"};